<template>
  <div id="app">
    <!-- 背景音乐 -->
    <audio ref="bgMusic" @ended="playNextSong">
      <source :src="currentSong" type="audio/mp3">
    </audio>
    <!-- 顶部导航 -->
    <nav class="nav-bar"
         v-if="
         $route.path !== '/game'
         && $route.path !== '/view'
      ">
      <div class="nav-content">
        <!-- 音乐控制按钮 -->
        <div class="music-control"
             @click="toggleMusic"
             title="点击播放/暂停背景音乐">
          <span class="music-icon" :class="{ 'playing': isPlaying }">🎵</span>
        </div>

        <!-- 歌单选择 -->
        <div class="music-control next-song"
             @click="togglePlaylist"
             title="选择歌曲">
          <span class="music-icon"><i class="fas fa-list"></i></span>
        </div>
        <!-- 歌单下拉菜单 -->
        <div class="playlist-dropdown" v-if="showPlaylist">
          <div class="playlist-item"
               v-for="(song, index) in songNames"
               :key="index"
               @click="selectSong(index)"
               :class="{ 'active': index === currentSongIndex }">
            {{ song }}
          </div>
        </div>
        <!-- 歌曲名称 -->
        <div class="song-name" v-if="isPlaying">
          <span>正在播放：{{ currentSongName }}</span>
        </div>
        <!-- 时间看板 -->
        <div class="time-board">
          <span class="time">{{ currentTime }}</span>
          <span class="date">{{ currentDate }}</span>
        </div>
        <div class="menu-icon" @click="toggleMenu">
          <i class="fas" :class="isMenuOpen ? 'fa-close' : 'fa-bars'"></i>
        </div>
        <div class="nav-links" :class="{ 'nav-active': isMenuOpen }">

          <router-link to ="/home" class="nav-link" active-class="active" @click="closeMenu">首页</router-link>
          <router-link to ="/about" class="nav-link" active-class="active" @click="closeMenu">关于万绿</router-link>
          <router-link to ="/gallery" class="nav-link" active-class="active" @click="closeMenu">高山绿茶</router-link>
          <router-link to ="/story" class="nav-link" active-class="active" @click="closeMenu">品牌故事</router-link>
          <router-link to ="/team" class="nav-link" active-class="active" @click="closeMenu">管理团队</router-link>
          <router-link to ="/funding" class="nav-link" active-class="active" @click="closeMenu">融资计划</router-link>
          <router-link to="/tbook" class="nav-link" active-class="active" @click="closeMenu">留言板</router-link>
            <router-link v-if="isAuthenticated" to="/notes" class="nav-link" active-class="active" @click="closeMenu">笔记本</router-link>
          <a href="http://shop.wanlvjiapin.com/" target="_blank" class="nav-link">桃香商城</a>
          <router-link v-if="!isAuthenticated" to="/auth" class="nav-link" active-class="active" @click="closeMenu">登录/注册</router-link>
                  <!-- 移动端用户信息 - 在汉堡菜单内 -->
        <div v-if="isAuthenticated" class="user-info-mobile">
          <div class="user-row">
            <span class="username" @click="goToProfile" title="点击进入个人设置">{{ currentUser?.username }}</span>
            <button @click="handleLogout" class="logout-btn">登出</button>
          </div>
        </div>
        </div>



        <!-- 用户信息区域 - 固定在右侧 -->
        <div v-if="isAuthenticated" class="user-info-fixed">
          <span class="username" @click="goToProfile" title="点击进入个人设置">{{ currentUser?.username }}</span>
          <button @click="handleLogout" class="logout-btn">登出</button>
        </div>
      </div>
    </nav>
    <!-- 固定位置的音乐控制按钮（仅在 intro 页面显示） -->
    <div class="music-control fixed"
         @click="toggleMusic"
         title="点击播放/暂停背景音乐"
         v-if="false">
      <span class="music-icon" :class="{ 'playing': isPlaying }">🎵</span>
    </div>
    <div class="main-content" :class="{ 'full-height': $route.path === '/' }">
      <router-view></router-view>
    </div>

    <!-- 滚动到顶部按钮 -->
    <ScrollToTop />

    <!-- 底部备案信息隐藏） -->
    <AppFooter v-if="$route.path !== '/'
     && $route.path !== '/invite'
     && $route.path !== '/game'
     && $route.path !== '/view'
   

" />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onBeforeUnmount, computed } from 'vue'
import AppFooter from '@/components/layout/Footer.vue'
import ScrollToTop from '@/components/ScrollToTop.vue'

import { wenVisit, updateVisitDuration } from '@/api/visit'

export default defineComponent({
  name: 'app',
  components: {
    AppFooter,
    ScrollToTop,

  },



  data() {
    return {
      isMenuOpen: false as boolean,
      isPlaying: false as boolean,
      currentSongIndex: 0,
      showPlaylist: false as boolean,
      currentTime: '',
      currentDate: '',
      // 添加响应式的认证状态
      authState: {
        user: null as any,
        isAuthenticated: false as boolean
      },
      songNames: [
        'I’ll Do It',
        'Let U Go',
        '我是愤怒',
        '死性不改',
        '平凡之路',
        '光年之外',
        '逆战',
        '玫瑰花的梦',
        '你要跳舞吗',
        '月亮照山川',
        '荷塘月色',
        '最美的太阳',
        '勋章',
        '稻香',
        '安妮',
        '最好的安排',
        '唯一',
        '倒带',
        '见面就告白吧',
        '伤感的恋人',
        '第一滴泪',
        '谁明浪子心'
      ],

      playlist: [
        require('@/assets/sounds/I ll Do It.mp3'),
        require('@/assets/sounds/Let U Go.mp3'),
        require('@/assets/sounds/woshifennu.mp3'),
        require('@/assets/sounds/sixingbugai.mp3'),
        require('@/assets/sounds/pingfanzhilu.mp3'),
        require('@/assets/sounds/guannianzhiwai.mp3'),
        require('@/assets/sounds/nizhan.mp3'),
        require('@/assets/sounds/meiguihuademeng.mp3'),
        require('@/assets/sounds/niyaotuiwuma.mp3'),
        require('@/assets/sounds/yueliang.mp3'),
        require('@/assets/sounds/hetangyuese.mp3'),
        require('@/assets/sounds/zuimei.mp3'),
        require('@/assets/sounds/xunzhang.mp3'),
        require('@/assets/sounds/daoxiang.mp3'),
        require('@/assets/sounds/anni.mp3'),
        require('@/assets/sounds/zuihaodeanpai.mp3'),
        require('@/assets/sounds/weiyi.mp3'),
        require('@/assets/sounds/daodai.mp3'),
        require('@/assets/sounds/gaobai.mp3'),
        require('@/assets/sounds/shanggandelianren.mp3'),
        require('@/assets/sounds/diyidilei.mp3'),
        require('@/assets/sounds/shuiminglangzixin.mp3')
      ]
    }
  },
  computed: {
    currentSong(): string {
      return this.playlist[this.currentSongIndex];
    },
    currentSongName(): string {
      return this.songNames[this.currentSongIndex];
    },
    currentUser() {
      const user = (this as any).authState.user;
      console.log('App.vue - currentUser computed called, value:', user);
      return user;
    },
    isAuthenticated() {
      const auth = (this as any).authState.isAuthenticated;
      console.log('App.vue - isAuthenticated computed called, value:', auth);
      return auth;
    }
  },
  watch: {
    // 监听路由变化
    '$route'(to, from) {
      // 确保所有路由变化都滚动到顶部
      if (to.path !== from.path) {
        this.$nextTick(() => {
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        });
      }
    }
  },
  methods: {
    toggleMenu(): void {
      this.isMenuOpen = !this.isMenuOpen;
      document.body.style.overflow = this.isMenuOpen ? 'hidden' : '';
    },
    updateDateTime(): void {
      const now = new Date();
      this.currentTime = now.toLocaleTimeString('zh-CN', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
      this.currentDate = now.toLocaleDateString('zh-CN', { month: 'long', day: 'numeric', weekday: 'long' });
    },
    closeMenu(): void {
      this.isMenuOpen = false;
      document.body.style.overflow = '';
      // 滚动到页面顶部
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    playNextSong(): void {
      this.currentSongIndex = (this.currentSongIndex + 1) % this.playlist.length;
      const audio = this.$refs.bgMusic as HTMLAudioElement;
      audio.load();
      // 播放完毕后自动播放下一首
      this.isPlaying = true;
      audio.play().then(() => {
        console.log('自动播放下一首歌曲:', this.currentSongName);
      }).catch(error => {
        console.log('播放下一首歌曲失败:', error);
        this.isPlaying = false;
      });
    },
    toggleMusic(): void {
      const audio = this.$refs.bgMusic as HTMLAudioElement;
      if (audio.paused) {
        // 用户手动点击播放
        audio.play().then(() => {
          this.isPlaying = true;
          console.log('音乐开始播放');
        }).catch(error => {
          console.log('音乐播放失败:', error);
          this.isPlaying = false;
        });
      } else {
        // 用户手动点击暂停
        audio.pause();
        this.isPlaying = false;
        console.log('音乐已暂停');
      }
    },
    initMusic(): void {
      // 移除自动播放逻辑，只初始化音乐系统，不自动播放
      console.log('音乐系统初始化完成，等待用户手动点击播放...');
    },
    togglePlaylist() {
      this.showPlaylist = !this.showPlaylist;
    },
    selectSong(index: number) {
      this.currentSongIndex = index;
      const audio = this.$refs.bgMusic as HTMLAudioElement;
      audio.load();
      // 选择歌曲后自动开始播放
      this.isPlaying = true;
      audio.play().then(() => {
        console.log('已选择并开始播放歌曲:', this.currentSongName);
      }).catch(error => {
        console.log('播放歌曲失败:', error);
        this.isPlaying = false;
      });
      this.showPlaylist = false;
    },
    handleLogout(): void {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      console.log('用户已登出');
      // 更新响应式状态
      this.authState.user = null;
      this.authState.isAuthenticated = false;
      // 尝试更新store状态（如果可用）
      if ((this as any).$store) {
        (this as any).$store.dispatch('updateUser', null);
      }
      // 跳转到登录页面
      this.$router.push('/auth');
    },

    goToProfile(): void {
      this.$router.push('/profile');
      this.closeMenu(); // 关闭移动端菜单
    },

    // 处理localStorage变化
    handleStorageChange(event: StorageEvent): void {
      if (event.key === 'token' || event.key === 'user') {
        console.log('检测到认证状态变化，重新检查状态');
        this.checkAuthStatus();
      }
    },




    checkAuthStatus(): void {
      const token = localStorage.getItem('token');
      const userStr = localStorage.getItem('user');

      console.log('checkAuthStatus called - token:', token ? 'exists' : 'null', 'userStr:', userStr ? 'exists' : 'null');

      if (token && userStr) {
        try {
          const user = JSON.parse(userStr);
          console.log('检查到已登录用户:', user);
          // 更新响应式状态
          this.authState.user = user;
          this.authState.isAuthenticated = true;
          console.log('authState updated - user:', this.authState.user, 'isAuthenticated:', this.authState.isAuthenticated);
          // 尝试更新store状态（如果可用）
          if ((this as any).$store) {
            (this as any).$store.dispatch('updateUser', user);
          }
        } catch (error) {
          console.error('解析用户信息失败:', error);
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          this.authState.user = null;
          this.authState.isAuthenticated = false;
        }
      } else {
        console.log('未检测到登录状态');
        this.authState.user = null;
        this.authState.isAuthenticated = false;
        console.log('authState cleared - user:', this.authState.user, 'isAuthenticated:', this.authState.isAuthenticated);
      }
    },

      },
    preventDoubleTapZoom(): void {
      // 检测是否为移动设备
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
                      ('ontouchstart' in window) ||
                      (navigator.maxTouchPoints > 0);

      // 防止双击放大（仅移动端）
      if (isMobile) {
        let lastTouchEnd = 0;
        document.addEventListener('touchend', (event) => {
          const now = (new Date()).getTime();
          if (now - lastTouchEnd <= 300) {
            event.preventDefault();
          }
          lastTouchEnd = now;
        }, false);

        // 防止双击选择文本（仅移动端）
        document.addEventListener('dblclick', (event) => {
          event.preventDefault();
        }, false);

        // 设置触摸操作（仅移动端）
        document.documentElement.style.touchAction = 'manipulation';
      }
    },
    mounted(): void {
      // 只初始化音乐系统，不自动播放
      this.initMusic();

      // 初始化时间
      this.updateDateTime();
      // 每秒更新时间
      setInterval(this.updateDateTime, 1000);

      // 检查用户登录状态
      console.log('App.vue mounted - 开始检查认证状态');
      this.checkAuthStatus();
      console.log('App.vue mounted - 认证状态检查完成，当前authState:', this.authState);

      // 将 app 实例挂载到 window 对象，供其他组件调用
      (window as any).app = this;

      // 监听localStorage变化
      window.addEventListener('storage', this.handleStorageChange);

      // 移除事件监听器
      window.removeEventListener('beforeunload', () => {
        updateVisitDuration();
      });

      // 在组件卸载前记录访问时长
      onBeforeUnmount(() => {
        updateVisitDuration();
        window.removeEventListener('storage', this.handleStorageChange);
      });
    }
})
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* 移动端禁止双击放大和长按保存图片 */
@media (max-width: 768px), (hover: none) and (pointer: coarse) {
  html, body {
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
  }

  /* 禁止图片长按保存 */
  img {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    pointer-events: none;
    touch-action: manipulation;
  }
}

body {
  font-family: 'Microsoft YaHei', Arial, sans-serif;
  line-height: 1.6;
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
  position: relative;
}

.main-content.full-height {
  height: 100vh;
  overflow: hidden;
}

/* 导航栏 */
.nav-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 7999;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  height: 50px;
  padding: 0;
  pointer-events: auto;
  background: #fff; /* 或 rgba(255,255,255,1) */
}

  .nav-content {
    max-width: 1400px;
    margin: 0 auto;
    height: 100%;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center; /* 改为居中对齐 */
    position: relative;
    padding-left: 100px; /* 为两个按钮留出空间 */
    padding-right: 150px; /* 为右侧用户信息留出空间 */
    flex-wrap: nowrap;
    white-space: nowrap;
  }

/* 歌曲名称基础样式 */
.song-name {
  display: flex;
  align-items: center;
  font-size: 12px;
  padding: 9px 18px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  color: #2e8b57;
  background: rgba(46, 139, 87, 0.1);
  border-radius: 15px;
  white-space: nowrap;
  z-index: 7998;
  pointer-events: none;
}

/* 响应式布局 - 大屏幕 (1400px+) */
@media (min-width: 1400px) {
  .song-name {
    position: absolute;
    left: 100px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 7998;
    background: rgba(46, 139, 87, 0.15);
    border: 1px solid rgba(46, 139, 87, 0.2);
    box-shadow: 0 2px 8px rgba(46, 139, 87, 0.1);
    padding: 6px 2px !important;
    border-radius: 18px !important;
    max-width: 80px !important;
    min-width: 80px !important;
    font-size: 13px !important;
  }
}

/* 响应式布局 - 中等屏幕 (1024px - 1399px) */
@media (min-width: 1024px) and (max-width: 1399px) {
  .song-name {
    position: absolute;
    left: 90px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 7998;
    background: rgba(46, 139, 87, 0.15);
    border: 1px solid rgba(46, 139, 87, 0.2);
    box-shadow: 0 2px 8px rgba(46, 139, 87, 0.1);
    padding: 5px 1px !important;
    border-radius: 16px !important;
    max-width: 80px !important;
    min-width: 80px !important;
    font-size: 12px !important;
  }
}

/* 响应式布局 - 小屏幕 (769px - 1023px) */
@media (min-width: 769px) and (max-width: 1023px) {
  .song-name {
    position: absolute;
    left: 80px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 7998;
    background: rgba(46, 139, 87, 0.15);
    border: 1px solid rgba(46, 139, 87, 0.2);
    box-shadow: 0 2px 8px rgba(46, 139, 87, 0.1);
    padding: 5px 0px !important;
    border-radius: 15px !important;
    max-width: 60px !important;
    min-width: 60px !important;
    font-size: 12px !important;
  }
}

/* 时间看板样式 */
.time-board {
  position: fixed;
  right: 50px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 2px;
  padding: 1px 15px;
  background: rgba(46, 139, 87, 0.1);
  border-radius: 15px;
  z-index: 7998;
  pointer-events: none;
}

.time-board .time {
  font-size: 14px;
  font-weight: 500;
  color: #2e8b57;
}

.time-board .date {
  font-size: 12px;
  color: #666;
}

/* 手机端时间看板样式 */
@media (max-width: 768px) {
  .time-board {
    position: absolute;
    right: 58px;
    padding: 2px 13px;
    align-items: center;
    text-align: center;
    min-width: 12px;
  }

  .time-board .time {
    font-size: 12px;
  }

  .time-board .date {
    font-size: 10px;
  }

  .song-name {
    position: absolute;
    left: 170px !important;
    transform: none;
    font-size: 11px;
    padding: 6px 12px;
    max-width: 12px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .nav-content {
    justify-content: flex-start;
    padding-right: 50px;
  }
}

/* 移除可能导致冲突的样式 */
@media (max-width: 768px) {
  .song-name {
    display: flex;
    font-size: 12px;
    padding: 9px 18px;
    transform: none;
  }
}

/* 菜单按钮样式 */
.menu-icon {
  display: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #2e8b57;
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  z-index: 7999;
  pointer-events: auto;
  transition: all 0.3s ease;
}

.menu-icon i {
  transition: all 0.3s ease;
  transform-origin: center;
}


  .nav-links {
    display: flex;
    gap: 1.5rem;
    align-items: center;
    justify-content: center; /* 导航链接居中对齐 */
    flex-wrap: nowrap;
    white-space: nowrap;
    overflow: hidden;
    flex: 1; /* 占据剩余空间 */
  }

.nav-link {
  color: #333;
  text-decoration: none;
  font-weight: 500;
  transition: all 0.3s ease;
  padding: 0.5rem 1rem;
  font-size: 0.95rem;
  border-radius: 20px;
  white-space: nowrap;
  flex-shrink: 0;
}

.nav-link:hover,
.nav-link.router-link-active {
  color: #2e8b57;
  background: rgba(46, 139, 87, 0.1);
}

.nav-link.active {
  color: #2e8b57;
  background: rgba(46, 139, 87, 0.1);
  font-weight: bold;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .menu-icon {
    display: block;
    z-index: 7999;
    pointer-events: auto;
    transition: all 0.3s ease;
  }

  .menu-icon i {
    transition: all 0.3s ease;
    transform-origin: center;
  }


  .nav-links {
    position: fixed;
    top: 80px;
    right: -100%;
    width: 100%;
    height: calc(100vh - 60px);
    background: rgba(255, 255, 255, 0.98);
    backdrop-filter: blur(10px);
    flex-direction: column;
    gap: 0;
    padding: 1rem;
    transition: right 0.3s ease;
    z-index: 7999;
    pointer-events: auto;
    justify-content: flex-start !important;
  }

  .nav-links.nav-active {
    right: 0;
  }

  .nav-link {
    width: 100%;
    padding: 1rem;
    text-align: center;
    font-size: 1.1rem;
    border-radius: 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }

  .nav-link:last-child {
    border-bottom: none;
  }

  .nav-link:hover,
  .nav-link.router-link-active {
    background: rgba(46, 139, 87, 0.1);
  }

  .song-name {
    display: flex;
    font-size: 12px;
    padding: 9px 18px;
  }
}

/* 音乐控制按钮样式 */
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.music-control {
  width: 28px;
  height: 28px;
  background: rgba(255, 255, 255, 0.9);
  border: 2px solid transparent;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 10px rgba(46, 139, 87, 0.2);
  position: absolute;
  background-image: linear-gradient(white, white), linear-gradient(135deg, #2e8b57, #2e8b57);
  background-origin: border-box;
  background-clip: content-box, border-box;
  z-index: 8000;
  pointer-events: auto;
}

.music-control:first-child {
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
}

.music-control.next-song {
  left: 60px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 8000;
  pointer-events: auto;
}

.music-control:hover {
  transform: translateY(-50%) scale(1.1);
  box-shadow: 0 4px 15px rgba(46, 139, 87, 0.3);
}

/* 电脑端样式覆盖 */
@media (min-width: 769px) {
  .music-control {
    width: 26px;  /* 减小按钮尺寸 */
    height: 26px;  /* 减小按钮尺寸 */
    border: 2px solid #2e8b57;  /* 减小边框宽度 */
    box-shadow: 0 2px 12px rgba(46, 139, 87, 0.4);
  }

  .music-control:first-child {
    left: 20px;
  }

  .music-control.next-song {
    left: 60px;
    z-index: 8000;
  }

  .music-control:hover {
    border-color: #2e8b57;
    box-shadow: 0 4px 15px rgba(46, 139, 87, 0.5);
  }

  .music-icon {
    font-size: 14px;
  }
}

  .music-icon {
    font-size: 10px;
    animation: none;
    color: #2e8b57;
    background: linear-gradient(135deg, #2e8b57, #2e8b57);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

.music-icon.playing {
  animation: rotate 3s linear infinite;
}

/* 调整导航内容的样式 */
.nav-content {
  position: relative;
  padding-left: 100px; /* 为两个按钮留出空间 */
}

/* 歌曲名称样式 */
.song-name {
  display: flex;
  align-items: left;
  font-size: 12px;
  padding: 8px 30px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  color: #2e8b57;
  background: rgba(46, 139, 87, 0.1);
  border-radius: 15px;
  white-space: nowrap;
  z-index: 6000;
  overflow: hidden;
  min-width: 100px;
}

/* 电脑端歌曲名称样式 - 已在上方统一定义 */

/* 手机端歌曲名称样式 */
@media (max-width: 768px) {
  .song-name {
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

@keyframes textScroll {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(-100%);
  }
}

.song-name span {
  display: inline-block;
  animation: textScroll 5s linear infinite;
}

/* 保持原有的音乐控制按钮样式 */
.music-control.fixed {
  position: fixed;
  top: 20px;
  right: 20px;
  left: auto;
  transform: none;
  z-index: 8000;
  pointer-events: auto;
}

.music-control.fixed:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 15px rgba(46, 139, 87, 0.3);
}

/* 歌单控制按钮样式 */
.playlist-control {
  left: 100px;
  top: 50%;
  transform: translateY(-50%) !important;
}

.playlist-control:hover {
  transform: translateY(-50%) scale(1.1) !important;
  box-shadow: 0 4px 15px rgba(46, 139, 87, 0.3);
}

@media (max-width: 768px) {
  .playlist-control {
    left: 60px;
  }
}

/* 歌单下拉菜单样式 */
.playlist-dropdown {
  position: absolute;
  left: 100px;
  top: 45px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  padding: 8px 0;
  z-index: 8000;
  min-width: 150px;
  pointer-events: auto;
}

.playlist-item {
  padding: 8px 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  color: #666;
  font-size: 14px;
  white-space: nowrap;
}

.playlist-item:hover {
  background: rgba(46, 139, 87, 0.1);
  color: #2e8b57;
}

.playlist-item.active {
  background: rgba(46, 139, 87, 0.1);
  color: #2e8b57;
  font-weight: 500;
}

@media (max-width: 768px) {
  .playlist-dropdown {
    left: 60px;
    top: 40px;
  }

  .playlist-item {
    padding: 6px 12px;
    font-size: 12px;
  }
}

.beian-link {
  font-size: 0.8rem;
  color: #999;
  padding: 0.3rem 0;
  transition: color 0.3s ease;
}

.beian-link:hover {
  color: #666;
}

@media (max-width: 768px) {
  .beian-link {
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    margin-top: 1rem;
    padding-top: 1rem;
  }
}

.fixed-beian {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(5px);
  padding: 8px 15px;
  border-radius: 20px;
  font-size: 0.8rem;
  color: #999;
  text-decoration: none;
  transition: all 0.3s ease;
  z-index: 1000;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.fixed-beian:hover {
  background: rgba(255, 255, 255, 0.95);
  color: #666;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
}

@media (max-width: 768px) {
  .fixed-beian {
    bottom: 10px;
    font-size: 0.75rem;
    padding: 6px 12px;
  }
}

/* 用户信息样式 */
.user-info {
  display: flex;
  align-items: center;
  gap: 10px;
}


/* 桌面端固定用户信息样式 */
.user-info-fixed {
  position: absolute;
  right: 35px;  /* 调整位置，与padding-right: 150px匹配 */
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  gap: 10px;
  z-index: 8000;
}

/* 移动端用户信息样式 */
.user-info-mobile {
  display: none;
  flex-direction: column;  /* 垂直排列，让笔记本单独一行 */
  align-items: center;
  justify-content: center;  /* 居中对齐 */
  gap: 15px;  /* 增加间距 */
  padding: 15px 0;
  margin-top: 0px;  /* 整体往上移动 */
}


/* 第一行用户信息样式 */
.user-row {
  display: flex;
  flex-direction: row;  /* 第一行保持水平排列 */
  align-items: center;
  gap: 15px;
}


.notes-link:hover,
.notes-link.router-link-active {
  color: #2e8b57;
  background: rgba(46, 139, 87, 0.1);
}

.notes-link.active {
  color: #2e8b57;
  background: rgba(46, 139, 87, 0.1);
  font-weight: bold;
}

/* 用户名基础样式 */
.username {
  color: #2e8b57;  /* 绿色主题，与导航栏其他元素保持一致 */
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.3s ease;
  text-decoration: none;
  background: none;  /* 移除背景 */
  border: none;  /* 移除边框 */
}

.username:hover {
  color: #2e8b57;  /* 悬停时保持绿色 */
  background: rgba(46, 139, 87, 0.1);  /* 悬停时显示淡绿色背景 */
  transform: translateY(-1px);
}

.logout-btn {
  background: linear-gradient(135deg, #ff4757 0%, #ff3742 100%);
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  transition: all 0.3s ease;
  box-shadow: 0 2px 6px rgba(255, 71, 87, 0.25);
  position: relative;
  overflow: hidden;
}

.logout-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s ease;
}

.logout-btn:hover::before {
  left: 100%;
}

.logout-btn:hover {
  background: linear-gradient(135deg, #ff3742 0%, #ff2f3a 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(255, 71, 87, 0.35);
  border-radius: 10px;
}

@media (max-width: 768px) {
  .user-info {
    flex-direction: column;
    gap: 5px;
  }

  /* 桌面端用户信息在移动端隐藏 */
  .user-info-fixed {
    display: none;
  }

  /* 移动端用户信息显示 */
  .user-info-mobile {
    display: flex;
    flex-direction: column;  /* 改为垂直排列，让笔记本单独一行 */
    align-items: center;
    justify-content: center;
    gap: 15px;
  }

  .username {
    font-size: 12px;
    padding: 4px 8px;
    border-radius: 15px;
    white-space: nowrap;  /* 防止用户名换行 */
  }

  .logout-btn {
    padding: 6px 12px;  /* 稍微增加按钮大小 */
    font-size: 11px;
    white-space: nowrap;  /* 防止按钮文字换行 */
  }
}
</style>
<script setup lang="ts">
</script>

